import { ArrowDown, ArrowUp, Blocks, ListTree } from "lucide-react";
import { TitleToolbar } from "@core/components/TitleToolbar";
import {
  getEnabledModules,
  getModuleNavigation,
  getModuleTopbarItems,
  orderModuleItems,
} from "@core/module-registry";
import { useAppPreferences } from "@core/preferences/AppPreferencesProvider";

export function ModulesSettingsPage() {
  const { preferences, setPreference, isModuleVisible, setModuleVisible } = useAppPreferences();
  const modules = getEnabledModules();
  const surfaces = [
    { id: "sidebar", label: "Desktop sidebar", items: getModuleNavigation() },
    { id: "topbar", label: "Desktop topbar", items: getModuleTopbarItems() },
    { id: "mobile", label: "Mobile appbar", items: getModuleNavigation() },
  ];

  const moveItem = (surface, itemId, direction, items) => {
    const ids = items.map((item) => item.id);
    const configured = preferences.navigationOrder?.[surface] ?? [];
    const ordered = [
      ...configured.filter((id) => ids.includes(id)),
      ...ids.filter((id) => !configured.includes(id)),
    ];
    const from = ordered.indexOf(itemId);
    const to = from + direction;
    if (from < 0 || to < 0 || to >= ordered.length) return;
    [ordered[from], ordered[to]] = [ordered[to], ordered[from]];
    setPreference("navigationOrder", (current) => ({
      ...(current ?? {}),
      [surface]: ordered,
    }));
  };

  return (
    <div className="settings-page-stack">
      <TitleToolbar
        density="compact"
        title="Modules and navigation"
        icon={Blocks}
      />
      <section className="settings-card module-settings-list">
        {modules.map((module) => {
          const visible = isModuleVisible(module.id, module.enabled !== false);
          return (
            <label key={module.id} className="module-setting-row">
              <span className="settings-list-icon"><Blocks /></span>
              <span><strong>{module.name}</strong><small>{module.description}</small><code>{module.id} · v{module.version}</code></span>
              <input className="vp-switch" type="checkbox" checked={visible} onChange={(event) => setModuleVisible(module.id, event.target.checked)} />
            </label>
          );
        })}
      </section>
      <section className="settings-card">
        <div className="settings-card-header">
          <span className="settings-list-icon"><ListTree /></span>
          <div><h2>Navigation surfaces</h2><p>Reorder navigation items for your workspace layout.</p></div>
        </div>
        <div className="navigation-surface-list">
          {surfaces.map((surface) => {
            const orderedItems = orderModuleItems(surface.items, preferences.navigationOrder?.[surface.id]);
            return (
              <div key={surface.id} className="navigation-surface-group">
                <strong>{surface.label}</strong>
                {orderedItems.map((item, index) => (
                  <div key={item.id} className="navigation-order-row">
                    <span><b>{item.label}</b><small>{item.moduleId} · {item.id}</small></span>
                    <div>
                      <button type="button" onClick={() => moveItem(surface.id, item.id, -1, orderedItems)} disabled={index === 0} aria-label={`Move ${item.label} up in ${surface.label}`}><ArrowUp /></button>
                      <button type="button" onClick={() => moveItem(surface.id, item.id, 1, orderedItems)} disabled={index === orderedItems.length - 1} aria-label={`Move ${item.label} down in ${surface.label}`}><ArrowDown /></button>
                    </div>
                  </div>
                ))}
              </div>
            );
          })}
        </div>
      </section>
    </div>
  );
}
